import { Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetsResultsMessagesSection } from 'Components/Worksheets/Core';
import { MddChartSection } from 'Components/Worksheets/MaximumDryDensityWorksheet/Shared';
import { GradningZoneType } from 'Components/Worksheets/MaximumDryDensityWorksheet/types';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';

const contextCaptions = [
  { path: `data.TestPortions`, caption: 'Test Portions' },
  { path: `data.Preparation`, caption: 'Preparation' },
  { path: `data.Equipment.Moulds`, caption: 'Moulds' },
];

let BsResultsSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const gradingZoneEqualsX = useSelector(
    pipe(createWorksheetSelector!('Preparation.GradingZone'), (t) => t === GradningZoneType.X)
  );

  const completeTestByAgreementWithClient = useSelector(
    pipe(createWorksheetSelector!('Preparation.CompleteTestByAgreementWithClient'), valueOrDefault(false))
  );

  return (
    <>
      <MddChartSection visible={!gradingZoneEqualsX || completeTestByAgreementWithClient} />
      <ListFieldSection heading="Laboratory Results">
        <Field input={<TextOutput />} name="Results.MaximumDryDensity" emph />
        <Field input={<TextOutput />} name="Results.OptimumMoistureContent" emph />
      </ListFieldSection>
      <WorksheetsResultsMessagesSection contextCaptions={contextCaptions} />
    </>
  );
};

BsResultsSection = withInjectedProps(BsResultsSection);

export { BsResultsSection };
export default BsResultsSection;
